import { createFileRoute } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/dispense")({
  beforeLoad: (args) => {
    replaceWithBareModule("/dispense", args.location);
    requirePerm("VIEW_DISPENSING")(args);
  },
  component: () => <PendingSurface titleKey="nav.dispense" />,
});
